import { render, staticRenderFns } from "./CourseCardForCandidate.vue?vue&type=template&id=21a87624&scoped=true"
import script from "./CourseCardForCandidate.vue?vue&type=script&lang=js"
export * from "./CourseCardForCandidate.vue?vue&type=script&lang=js"
import style0 from "./CourseCardForCandidate.vue?vue&type=style&index=0&id=21a87624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a87624",
  null
  
)

export default component.exports